<template>

  <!-- use cases -->
  <v-row id="usecases" no-gutters class="mb-16">
    <v-col cols="12">
      <h1 v-heading>Anwendungsfälle</h1>
      <p>Entdecken Sie, wie unsere Software in verschiedenen Bereichen eingesetzt werden kann, um Effizienz und Kundenzufriedenheit zu steigern.</p>
    </v-col>
    <v-col 
      v-for="(usecase, index) in usecases" 
      :key="usecase.title" 
      cols="12" 
      class="pa-0 mb-4 pa-sm-2"
    >
      <UseCaseCard :usecase="usecase" :is-even="index % 2 === 0" />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import UseCaseCard from '@/components/public/UseCaseCard.vue';

definePageMeta({
  layout: 'default-public',
});

useHead({
  title: 'Anwendungsfälle für verschiedene Branchen',
  meta: [
    {
      name: 'description',
      content: 'Erfahren Sie, wie unsere Software in verschiedenen Branchen eingesetzt werden kann, um Effizienz und Kundenzufriedenheit zu steigern.'
    },
    {
      name: 'keywords',
      content: 'Software, Terminplanung, Kundenverwaltung, Effizienz, Kundenzufriedenheit, Friseur, Nagelstudio, Massage, Physiotherapeut'
    },
    {
      name: 'author',
      content: 'Termintiger'
    },
    {
      property: 'og:title',
      content: 'Anwendungsfälle für verschiedene Branchen'
    },
    {
      property: 'og:description',
      content: 'Erfahren Sie, wie unsere Software in verschiedenen Bereichen eingesetzt werden kann, um Effizienz und Kundenzufriedenheit zu steigern.'
    },
    {
      property: 'og:image',
      content: 'https://www.termintiger.com/images/usecases/hairstudio.jpg'
    },
    {
      property: 'og:url',
      content: 'https://www.termintiger.com/usecases'
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image'
    },
    {
      name: 'twitter:title',
      content: 'Anwendungsfälle für verschiedene Branchen'
    },
    {
      name: 'twitter:description',
      content: 'Erfahren Sie, wie unsere Software in verschiedenen Bereichen eingesetzt werden kann, um Effizienz und Kundenzufriedenheit zu steigern.'
    },
    {
      name: 'twitter:image',
      content: 'https://www.termintiger.com/images/usecases/hairstudio.jpg'
    }
  ],
});

const usecases = [
  {
    image: "/images/usecases/hairstudio.jpg",
    title: 'Friseur',
    description: 'Revolutionieren Sie die Terminplanung und Kundenverwaltung in Ihrem Friseursalon.',
    benefit: 'Minimieren Sie Wartezeiten und maximieren Sie die Kundenzufriedenheit.',
    details: 'Stellen Sie sich vor, Sie betreiben einen Friseursalon. Mit unserer hochmodernen Software können Sie Termine mühelos verwalten, detaillierte Kundenprofile pflegen und automatische Erinnerungen versenden. Dies führt zu einer optimalen Ressourcennutzung und einer erstklassigen Organisation Ihres Salons. Ihre Kunden werden die kürzeren Wartezeiten und die personalisierten Dienstleistungen lieben, was zu einer höheren Kundenzufriedenheit und -bindung führt.'
  },
  {
    image: "/images/usecases/nailstudio.jpg",
    title: 'Nagelstudio',
    description: 'Effiziente Termin- und Kundenverwaltung für Ihr Nagelstudio.',
    benefit: 'Erhöhen Sie die Effizienz und stärken Sie die Kundenbindung.',
    details: 'Nehmen wir an, Sie leiten ein Nagelstudio. Mit unserer innovativen Lösung können Sie Ihre Terminplanung automatisieren, Kundenpräferenzen speichern und gezielte Marketingaktionen durchführen. Dies optimiert Ihre Dienstleistungen und maximiert die Kundenzufriedenheit. Ihre Kunden werden die personalisierten Angebote und die reibungslose Terminverwaltung schätzen, was zu einer stärkeren Kundenbindung führt.'
  },
  {
    image: "/images/usecases/massage.jpg",
    title: 'Massage',
    description: 'Perfekte Planung und Verwaltung von Massageterminen und Kunden.',
    benefit: 'Optimieren Sie die Ressourcennutzung und steigern Sie die Kundenzufriedenheit.',
    details: 'Angenommen, Sie betreiben ein Massagestudio. Unsere Software unterstützt Sie dabei, Massagetermine effizient zu organisieren, wertvolles Kundenfeedback zu sammeln und Ihre Dienstleistungen kontinuierlich zu verbessern. Dies führt zu einer höheren Auslastung und zufriedeneren Kunden. Ihre Kunden werden die personalisierten Massagen und die einfache Terminbuchung zu schätzen wissen, was zu einer höheren Kundenzufriedenheit führt.'
  },
  {
    image: "/images/usecases/physio.jpg",
    title: 'Physiotherapeut',
    description: 'Effiziente Verwaltung von Patienten und Terminen in Ihrer Physiotherapiepraxis.',
    benefit: 'Steigern Sie die Produktivität und verbessern Sie die Patientenzufriedenheit.',
    details: 'Stellen Sie sich vor, Sie sind Physiotherapeut. Mit unserer fortschrittlichen Software können Sie Patientenakten digital verwalten, individuelle Therapiepläne erstellen und die Kommunikation mit Ihren Patienten optimieren. Dies trägt zu einer besseren Behandlung und einer höheren Patientenzufriedenheit bei. Ihre Patienten werden die personalisierte Betreuung und die effiziente Terminverwaltung schätzen, was zu einer höheren Zufriedenheit und Loyalität führt.'
  }
];
</script>
